module.exports = __webpack_public_path__ + "img/189.c743ae22.jpg";